/**
 * The steps of docs/08, in order.
 *
 * Steps 1-6 are a wizard inside the single route `/:merchantSlug/returns`: they share one
 * in-memory draft and none of them is meaningfully bookmarkable. Submitting hands off
 * straight to tracking (SAI-1324): there is no confirmation step to click through, the
 * tracking page states the reference once and is the confirmation. Tracking has its own
 * route because docs/08 requires it be "reachable directly, not only after submitting".
 *
 * Declared in its own module so `routes.tsx` (which imports the screens) and
 * `FlowProvider` (which the screens import) can both read it without a cycle.
 */
export const FLOW_STEPS = [
  "lookup",
  "items",
  "reason",
  "evidence",
  "resolution",
  "review",
] as const;

export type FlowStepId = (typeof FLOW_STEPS)[number];

/** Step 7. Not part of the wizard sequence. */
export const TRACK_STEP = "track" as const;

export type StepId = FlowStepId | typeof TRACK_STEP;

export const ALL_STEPS: readonly StepId[] = [...FLOW_STEPS, TRACK_STEP];

/** 1-based position for `<StepHeader>`. */
export function stepNumber(step: FlowStepId): number {
  return FLOW_STEPS.indexOf(step) + 1;
}
